// src/pages/Book/AllBookReviews.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BookReviewManager from "../../../services/home/BookReviewManager";
import { Star } from "lucide-react";
import config from "../../../config";

const AllBookReviews = () => {
  const { id } = useParams();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchReviews() {
      try {
        const data = await BookReviewManager.getReviewsByBook(id);
        setReviews(data || []);
      } catch (err) {
        console.error("Error loading reviews", err);
      } finally {
        setLoading(false);
      }
    }

    fetchReviews();
  }, [id]);

  if (loading) return <div className="text-primary">Loading reviews...</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-10 font-nunito">
      <h1 className="text-2xl font-bold mb-6 text-text-muted">All Reviews</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {reviews.map((review) => (
          <div
            key={review.reviewId}
            className="bg-white rounded-xl p-4 shadow hover:shadow-lg transition space-y-2 text-sm"
          >
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden">
                {review.user?.profilePhotoUrl ? (
                  <img
                    src={`${config.url}/userImages/${review.user.profilePhotoUrl}`}
                    alt="User Avatar"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span className="text-white font-bold text-base">
                    {review.user?.firstName?.[0]}
                  </span>
                )}
              </div>
              <div>
                <p className="font-semibold text-sm">
                  {review.user?.firstName} {review.user?.lastName}
                </p>
                <p className="text-xs text-gray-500">
                  {new Date(
                    review.creationDate[0],
                    review.creationDate[1] - 1,
                    review.creationDate[2]
                  ).toLocaleDateString()}
                </p>
              </div>
            </div>

            <div className="flex text-yellow-400 mt-1">
              {Array.from({ length: 5 }, (_, i) => (
                <Star
                  key={i}
                  size={14}
                  fill={i < review.rating ? "#FACC15" : "none"}
                  strokeWidth={1}
                />
              ))}
            </div>

            <p className="text-[11px] text-primary font-semibold">
              Verified Purchase
            </p>

            <p className="text-gray-700 text-sm leading-snug line-clamp-none">
              {review.review}
            </p>

            <div className="flex gap-4 text-xs text-primary mt-2">
              <button className="hover:underline">Helpful</button>
              <button className="hover:underline">Report</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllBookReviews;
